"use client";
import { message } from '@/components';
import { useWeb3Modal } from '@web3modal/wagmi/react'
import { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { useAccount, useChainId, useSignMessage, useDisconnect, useSwitchChain } from 'wagmi';
import { useEthersSigner } from "./UseEthersProvider";
import { getCustomerApi } from "@/services";
import Cookies from 'js-cookie'
import { GlobalContext } from '@/context';

const customerApi = getCustomerApi()


export const useConnect = () => {
  const { open, close } = useWeb3Modal();
  const [loading, setLoading] = useState(false);
  const { disconnect } = useDisconnect();
  const { updateLoggingIn } = useContext(GlobalContext);
  const connectRef = useRef(false);
  const {chainId, address, isConnecting, isConnected} = useAccount();
  const configChainId = useChainId();
  const { switchChain } = useSwitchChain()
  const {
    error: signError
  } = useSignMessage()
  const singer = useEthersSigner();
  const onConnect = useCallback(async () => {
    connectRef.current = true;
    await open();
  }, []);
  const getWallet = async() => {
    setLoading(true);
    // @ts-ignore
    const res = await customerApi.seasons.authChallenge({address: address as string, chainId: chainId.toString()})
    try {
      const signature = await singer?.signMessage(res?.data?.obj as string);
      const bindRes = await customerApi.seasons?.authConnect({
        address,
        signature,
      });
      const success = bindRes.data.success;
      setLoading(false);
      if(!success) {
        message({
          content:'Oops...Something went wrong. Please try again.',
          className:'message-error'
        })
        onDisconnect();
        return;
      }
      if (!!bindRes?.data?.obj) {
        Cookies.set("jwt_token", bindRes?.data?.obj)
        updateLoggingIn?.(true)
      } else {
        message({
          content:'Oops...Something went wrong. Please try again.',
          className:'message-error'
        })
        onDisconnect();
      }
      
    } catch (error) {
      setLoading(false);
      onDisconnect()
    }
  };
  useEffect(() => {
    if (isConnected && address && singer && connectRef.current) {
      if(configChainId !== chainId) {
        switchChain({chainId:configChainId})
      }
      getWallet();
    }
  }, [isConnected, singer, address])
  useEffect(() => {
    console.log("line55", signError);
    if(!!signError) {
      onDisconnect()
      setLoading(false);
    }
  }, [signError])

  const onDisconnect = () => {
    disconnect?.();
    close?.();
    Cookies.set("jwt_token", "")
    updateLoggingIn?.(false)
    connectRef.current=false;
  }

  return {
    onConnect,
    address,
    isConnecting,
    onDisconnect,
    isConnected,
    loading,
    getWallet,
    singer,
    connectRef
  };
}